import React from "react";
import LoadingSpin from "../../components/LoadingSpin";
import ErrorMessage from "../../components/ErrorMessage";
import {BrowserRouter as Router, Redirect} from "react-router-dom";
import {Form, Col, InputGroup, Button, ButtonGroup} from "react-bootstrap";
import {config} from "../../components/Constants";

class ClientsAdd extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            error: null,
            submitError: null,
            isLoaded: true,
            isLoggedIn: false,
            isSubmitting: false,
            redirect: null,
            client: null
        };
        this.handleSubmitForm = this.handleSubmitForm.bind(this);
        this.handleReturn = this.handleReturn.bind(this);
    }

    componentDidMount() {
    }

    handleSubmitForm(event) {
        if (event && event.preventDefault) {
            event.preventDefault();
        }
        this.setState({
            isSubmitting: true
        });
        const formData = new FormData(event.target);
        let data = {};
        formData.forEach((val, mkey) => {
            data[mkey] = val;
        });
        fetch(config.API_URL + '/api/clients/update',{
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            credentials: 'include',
            'method': 'POST',
            'body': JSON.stringify(data)
        })
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.error) {
                        this.setState({
                            isSubmitting: false,
                            submitError: result.error
                        });
                    } else if (result) {
                        this.setState({
                            isSubmitting: false,
                            redirect: '/clients'
                        });
                    }
                },
                (error) => {
                    this.setState({
                        isSubmitting: false,
                        submitError: error
                    });
                }
            );
        return false;
    }

    handleReturn(event) {
        if (event && event.preventDefault) {
            event.preventDefault();
        }
        this.setState({
            redirect: '/clients'
        });
        return false;
    }

    render() {
        const {error, isLoaded, isLoggedIn, isSubmitting, submitError, redirect, client} = this.state;
        const that = this;
        if (!isLoaded) {
            return (
                <LoadingSpin/>
            );
        } else if (redirect !== null) {
            return <Redirect to={redirect}/>
        } else if (error) {
            return (
                <ErrorMessage title="Pojawiły się błędy" text={error} buttons={[
                    {'title': 'Powrót', 'callback': function() {that.setState({redirect: '/clients', error: null});}}
                ]} handleClose={() => {that.setState({redirect: '/clients', error: null});}}/>
            );
        } else {
            return (
                <React.Fragment>
                    {isSubmitting ? <LoadingSpin/> : ''}
                    <header className="clients-header">
                        <h1>Edycja klienta {client.nazwa}</h1>
                    </header>
                    <div className="section-div">
                        {submitError !== null ? <ErrorMessage title="Pojawiły się błędy" text={submitError} buttons={[
                            {'title': 'OK', 'callback': function() {that.setState({submitError: null});}}
                        ]} handleClose={() => {that.setState({submitError: null});}}/> : ''}
                        <Form method="post" onSubmit={this.handleSubmitForm}>
                            <Form.Control type="hidden" defaultValue={client.id} name="id"/>
                            <h2>Dane podstawowe:</h2>
                            <Form.Row>
                                <Form.Group as={Col} md={6} sm={12} controlId="formGridName">
                                    <Form.Label>
                                        Nazwa obiektu:
                                    </Form.Label>
                                    <Form.Control defaultValue={client.nazwa} name="nazwa" type="text" placeholder="Wprowadź nazwę obiektu" required={true}/>
                                </Form.Group>
                                <Form.Group as={Col} md={6} sm={12} controlId="formGridSubd">
                                    <Form.Label>
                                        Subdomena:
                                    </Form.Label>
                                    <InputGroup>
                                        <InputGroup.Prepend>
                                            <InputGroup.Text id="inputGroupPrepend">https://</InputGroup.Text>
                                        </InputGroup.Prepend>
                                        <Form.Control defaultValue={client.subd} name="subd" type="text" placeholder="Wprowadź subdomenę" required={true}/>
                                        <InputGroup.Append>
                                            <InputGroup.Text id="inputGroupAppend">.sim.horecaidea.pl</InputGroup.Text>
                                        </InputGroup.Append>
                                    </InputGroup>
                                </Form.Group>
                            </Form.Row>
                            <h2>Ustawienia:</h2>
                            <Form.Row>
                                <Form.Group as={Col} lg={3} md={6} sm={12} controlId="formGridWeb">
                                    <Form.Check
                                        label="Web włączony"
                                        name="web_aplikacja"
                                        type="switch"
                                        defaultChecked={client.web_aplikacja === 2 ? true : false}
                                        defaultValue="2"
                                    />
                                </Form.Group>
                                <Form.Group as={Col} lg={3} md={6} sm={12} controlId="formGridExtranet">
                                    <Form.Check
                                        label="Extranet"
                                        name="extranet"
                                        type="switch"
                                        defaultValue="1"
                                        defaultChecked={client.extranet === 1 ? true : false}
                                    />
                                </Form.Group>
                                <Form.Group as={Col} lg={3} md={6} sm={12} controlId="formGridMail">
                                    <Form.Check
                                        label="Poczta"
                                        name="czy_poczta"
                                        type="switch"
                                        defaultValue="1"
                                        defaultChecked={client.czy_poczta === 1 ? true : false}
                                    />
                                </Form.Group>
                                <Form.Group as={Col} lg={3} md={6} sm={12} controlId="formGridMobi">
                                    <Form.Check
                                        label="Aplikacja Mobilna"
                                        name="czy_mobile"
                                        type="switch"
                                        defaultValue="1"
                                        defaultChecked={client.czy_mobile === 1 ? true : false}
                                    />
                                </Form.Group>
                                <Form.Group as={Col} lg={3} md={6} sm={12} controlId="formGridHIMedia">
                                    <Form.Check
                                        label="HI Media"
                                        name="czy_himedia"
                                        type="switch"
                                        defaultValue="1"
                                        defaultChecked={client.czy_himedia === 1 ? true : false}
                                    />
                                </Form.Group>
                                <Form.Group as={Col} lg={3} md={6} sm={12} controlId="formGridKartaEventu">
                                    <Form.Check
                                        label="Karta Eventu"
                                        name="czy_karta_eventu"
                                        type="switch"
                                        defaultValue="1"
                                        defaultChecked={client.czy_karta_eventu === 1 ? true : false}
                                    />
                                </Form.Group>
                                <Form.Group as={Col} lg={3} md={6} sm={12} controlId="formGridKartaProjektu">
                                    <Form.Check
                                        label="Karta Projektu"
                                        name="czy_karta_projektu"
                                        type="switch"
                                        defaultChecked={client.czy_karta_projektu === 1 ? true : false}
                                        defaultValue="1"
                                    />
                                </Form.Group>
                            </Form.Row>
                            <div className="downbuttons">
                                <Button type="submit" name="submit">Zapisz</Button> <Button onClick={this.handleReturn}>Powrót</Button>
                            </div>
                        </Form>
                    </div>
                </React.Fragment>
            );
        }
    }
}

export default ClientsAdd;